document.querySelectorAll(".visa-choice-form__quantity").forEach(initQuantity);
document.querySelectorAll(".visa-choice-form").forEach(initVisaChoiceForm);

const VISA_MID = 1; // mod_visa в таблице modules

function formatRub(n) {
	return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, "\u00a0") + "\u00a0₽";
}

// Пересчёт стоимости (цена выбранной срочности × количество) + создание заказа.
function initVisaChoiceForm(form) {
	const summary = form.querySelector(".visa-choice-form__summary-price");
	const countInput = form.querySelector(".visa-choice-form__quantity-input");
	const submitBtn = form.querySelector(".form__nav-btn");

	const selected = (name) => form.querySelector(`input[name="${name}"]:checked`);

	function unitPrice() {
		const urgency = selected("visa-urgency");
		const price = urgency ? parseInt(urgency.dataset.price, 10) : NaN;
		return Number.isNaN(price) ? 0 : price;
	}

	function count() {
		const n = parseInt(countInput && countInput.value, 10);
		return Number.isNaN(n) || n < 1 ? 1 : n;
	}

	function recalc() {
		if (summary) summary.textContent = formatRub(unitPrice() * count());
	}

	form.addEventListener("change", recalc);

	// Выбор «Мульти» — предупреждаем про билеты (попап Popup-visa-multi).
	form.addEventListener("change", (e) => {
		if (e.target.name === "visa-category" && e.target.value === "multi" && window.popup) {
			window.popup.open("visa-multi");
		}
	});
	form.addEventListener("input", recalc);
	recalc();

	// Текущий выбор формы → параметры заказа.
	function currentParams() {
		const urgency = selected("visa-urgency");
		const category = selected("visa-category");
		return {
			urgent: urgency && urgency.value === "urgent" ? 1 : 0,
			category: category ? category.value : "single",
			count: count(),
		};
	}

	// Создание заказа на сервере. Если сервер требует авторизацию — открываем попап
	// и запоминаем выбор в памяти (pendingParams), чтобы после входа дозавершить заказ.
	async function createOrder(params) {
		const data = new FormData();
		data.set("action", "createOrder");
		data.set("urgent", params.urgent);
		data.set("category", params.category);
		data.set("count", params.count);

		if (submitBtn) submitBtn.disabled = true;
		try {
			const res = await fetch(`/ajax.php?mid=${VISA_MID}`, { method: "POST", body: data });
			const json = await res.json();
			if (json.success && json.redirect) {
				window.location.href = json.redirect;
				return;
			}
			if (json.auth_required) {
				gateToAuth(params);
				return;
			}
			console.warn("[visa] заказ не создан:", json.error);
			alert(json.error || "Не удалось создать заказ");
		} catch (err) {
			console.error("[visa] ошибка создания заказа:", err);
		}
		if (submitBtn) submitBtn.disabled = false;
	}

	// Не авторизованы: запоминаем выбор в памяти и открываем попап входа.
	let pendingParams = null;
	function gateToAuth(params) {
		pendingParams = params;
		if (window.popup) window.popup.open("auth");
		if (submitBtn) submitBtn.disabled = false;
	}

	form.addEventListener("submit", (e) => {
		e.preventDefault();
		const params = currentParams();
		// Авторизация известна с сервера (data-authed); если нет — гейтим без лишнего запроса.
		if (form.dataset.authed === "1") createOrder(params);
		else gateToAuth(params);
	});

	// После входа (Popup-auth.js шлёт auth:success, без перезагрузки) — переотправляем
	// тот же заказ. Сессия уже выставлена сервером, поэтому createOrder пройдёт гейт.
	document.addEventListener("auth:success", () => {
		if (!pendingParams) return;
		const params = pendingParams;
		pendingParams = null;
		createOrder(params);
	});
}

function initQuantity(root) {
	const input = root.querySelector(".visa-choice-form__quantity-input");
	if (!input) return;

	const minAttr = parseInt(input.getAttribute("min"), 10);
	const maxAttr = parseInt(input.getAttribute("max"), 10);
	const MIN = Number.isNaN(minAttr) ? 1 : minAttr;
	const hasMax = !Number.isNaN(maxAttr);

	const minusBtn = root.querySelector(".visa-choice-form__quantity-btn--minus");
	const plusBtn = root.querySelector(".visa-choice-form__quantity-btn--plus");

	const clamp = (n) => Math.max(MIN, hasMax ? Math.min(maxAttr, n) : n);

	const syncButtons = () => {
		const n = parseInt(input.value, 10) || MIN;
		if (minusBtn) minusBtn.disabled = n <= MIN;
		if (plusBtn) plusBtn.disabled = hasMax && n >= maxAttr;
	};

	// разрешаем только цифры (без e, +, -, ., пробелов)
	input.addEventListener("keydown", (e) => {
		if (e.ctrlKey || e.metaKey || e.altKey) return;
		if (e.key.length === 1 && !/\d/.test(e.key)) e.preventDefault();
	});

	// фильтруем вставку/ввод; верхнюю границу применяем сразу, нижнюю — на blur
	input.addEventListener("input", () => {
		const digits = input.value.replace(/\D/g, "");
		const capped = hasMax && digits && +digits > maxAttr ? String(maxAttr) : digits;
		if (capped !== input.value) input.value = capped;
		syncButtons();
	});

	// пусто или меньше минимума → возвращаем минимум
	input.addEventListener("blur", () => {
		const n = parseInt(input.value, 10);
		input.value = Number.isNaN(n) ? MIN : clamp(n);
		syncButtons();
	});

	const step = (delta) => {
		const n = parseInt(input.value, 10);
		input.value = clamp((Number.isNaN(n) ? MIN : n) + delta);
		syncButtons();
		input.dispatchEvent(new Event("change", { bubbles: true }));
	};

	if (minusBtn) minusBtn.addEventListener("click", () => step(-1));
	if (plusBtn) plusBtn.addEventListener("click", () => step(1));

	// нормализация начального значения
	const start = parseInt(input.value, 10);
	input.value = Number.isNaN(start) ? MIN : clamp(start);
	syncButtons();
}
